module.exports = __webpack_public_path__ + "static/media/app-preview-02.e46828ad.png";